var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"toasts",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.toasts),function(toast){return _c('li',{key:toast.id,class:["toast", toast.type]},[_vm._v("\n    "+_vm._s(toast.message)+"\n  ")])}))}
var staticRenderFns = []

export { render, staticRenderFns }